import { debounce } from '../../js/utils';

const navigationSub = () => {
	const el = document.querySelector('.c-navigation-sub');
	const elActiveClass = 'c-navigation-sub--active';
	const list = document.querySelector('.c-navigation-sub__list');
	const toggle = document.querySelector('.c-navigation-sub__toggle');

	if (!list) {
		return;
	}

	const updateHiddenAttributes = () => {
		// If mobile, tweak aria attrs for dropdown
		if (window.matchMedia('(max-width: 575px)').matches) {
			// initially make sure dropdown is hidden
			list.setAttribute('hidden', true);
			list.setAttribute('aria-hidden', true);

			// remove active class from navigation
			el.classList.remove(elActiveClass);

			// set expanded attr to false
			toggle.setAttribute('aria-expanded', false);
		} else {
			// on desktop, dropdown is shown inline
			list.removeAttribute('hidden');
			list.setAttribute('aria-hidden', false);
		}
	};

	// Run utility on page load
	updateHiddenAttributes();

	// Mobile menu toggle interactivity
	toggle.addEventListener('click', () => {
		el.classList.toggle(elActiveClass);

		// Test if toggle is active or not
		const isActive = el.classList.contains(elActiveClass);

		// update aria hidden attribute
		list.setAttribute('aria-hidden', !isActive);

		// if not active, menu should be hidden
		if (!isActive) {
			list.setAttribute('hidden', true);
		} else {
			// otherwise, hide from screen readers
			list.removeAttribute('hidden');
		}

		// update toggle attrs if active
		toggle.setAttribute('aria-expanded', isActive);
	});

	// Run update util on window resize event
	window.addEventListener('resize', debounce(() => updateHiddenAttributes()));
};

export default navigationSub;
